export const PluginConnected = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.66683 5.08366H7.16683V4.58366V2.29199C7.16683 2.22296 7.22279 2.16699 7.29183 2.16699C7.36086 2.16699 7.41683 2.22296 7.41683 2.29199V4.58366V5.08366H7.91683H12.0835H12.5835V4.58366V2.29199C12.5835 2.22296 12.6395 2.16699 12.7085 2.16699C12.7775 2.16699 12.8335 2.22296 12.8335 2.29199V4.58366V5.08366H13.3335H14.3752C15.3647 5.08366 16.1668 5.88582 16.1668 6.87533V11.8753C16.1668 13.7853 14.6185 15.3337 12.7085 15.3337H10.6252H10.1252V15.8337V17.7087C10.1252 17.7777 10.0692 17.8337 10.0002 17.8337C9.93113 17.8337 9.87516 17.7777 9.87516 17.7087V15.8337V15.3337H9.37516H7.29183C5.38184 15.3337 3.8335 13.7853 3.8335 11.8753V6.87533C3.8335 5.88582 4.63565 5.08366 5.62516 5.08366H6.66683Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
)

export default PluginConnected
